import { Component, OnInit } from '@angular/core'
import { GrowthToolkitClient, AvailablePracticeInfo } from '../../services/ppv.api'
import { ActivatedRoute } from '@angular/router'
import { PhonePipe } from '../../pipes/phone.pipe';

@Component({
   selector: 'vc-hospital-info-column',
   templateUrl: './hospital-info-column.component.html',
   styleUrls: ['./hospital-info-column.component.scss'],
   standalone: false,
})
export class HospitalInfoColumnComponent implements OnInit {
   hospitalInfo: AvailablePracticeInfo

   //prettier-ignore
   constructor(
      private growthToolkitClient: GrowthToolkitClient,
	  private route: ActivatedRoute
   ) {}

   ngOnInit(): void {
      const practiceSKey = this.route.snapshot.paramMap.get('practiceSKey')
      this.getHospitalInfo(Number.parseInt(practiceSKey))
   }

   getHospitalInfo(PracticeSKey: number) {
      this.growthToolkitClient.getHospitalInfo(PracticeSKey).subscribe((data) => {
         this.hospitalInfo = data
      })
   }
}
